import classNames from 'classnames';
import * as React from 'react';

import { mapStringToCurrencySymbol } from '../../mappers/common/common';
import { Bem } from '../../service/Bem/Bem';
import { MoneyText } from '../MoneyText/MoneyText';
import { ValueOrDash } from '../ValueOrDash/ValueOrDash';

interface Props {
    num?: number;
    currency?: string;
    cls?: string;
    fractionalPartLength?: number;
}

export class MoneyCell extends React.PureComponent<Props> {
    render() {
        const { num, currency, cls, fractionalPartLength = 2 } = this.props;

        return (
            <div className={classNames(cls, Bem.cls('money-cell'))}>
                <ValueOrDash value={num}>
                    <MoneyText
                        num={num}
                        fractionalPartLength={fractionalPartLength}
                        currency={
                            currency === undefined
                                ? undefined
                                : mapStringToCurrencySymbol(currency)
                        }
                    />
                </ValueOrDash>
            </div>
        );
    }
}
